import { fork, put, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import { PerplayLogApi, LogControllerDtoEvolveLogListRequest } from '../../models/src';
import {
  evolveLogList,
  setEvolveLogPagination,
  setTotalCount
} from '../../actions/log/evolveLogActions';
import { EVOLVELOG_LIST_REQUEST } from '../../constants/log/evolveLogConstants';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import LogControllerDtoEvolveLogListResponse from '../../models/src/model/LogControllerDtoEvolveLogListResponse';

const api = new PerplayLogApi(config.API_CLIENT);

function* evolveLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoEvolveLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.account = payload.account;
    requestData.nftUid = payload.nftUid;
    requestData.usedNftUid = payload.usedNftUid;
    requestData.usedBooster = payload.usedBooster;
    requestData.usedSuperBooster = payload.usedSuperBooster;
    console.log('requestData: ', requestData);

    const result = yield api.apiPerplayLogEvolveLogListPost({ logControllerDtoEvolveLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoEvolveLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    yield put(evolveLogList(data.list));
    yield put(setTotalCount(data.totalCount));
    yield put(setEvolveLogPagination(
      payload.page,
      data.totalCount,
      payload.beginDate,
      payload.endDate,
      payload.searchCode,
      payload.searchString,
    ));
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* evolveLogRootSaga() {
  yield all([
    takeEvery(EVOLVELOG_LIST_REQUEST, evolveLogListRequestSaga),
  ])
}

const evolveLogSagas = [
  fork(evolveLogRootSaga),
];

export default evolveLogSagas;
